var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hover-dot", class: { "show-slide": _vm.slide } },
    [
      _c("div", {
        staticClass: "play-icon",
        class: { "spin-ani": this.linkAudio && this.linkAudio.isPlaying },
        style: { backgroundImage: `url(${_vm.linkAudio.icon})` },
        on: { click: _vm.slideShow },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "close-btn", on: { click: _vm.pauseAudio } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }